import { IconClose, IconTickSingle } from "@aksara-ui/icons";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogProps,
  Stack,
  Text,
  theme,
} from "@aksara-ui/react";
import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { storeVerifyKTP } from "redux/actions";

interface Props {
  userId: string;
  catalogId: string | undefined;
}

const KTPVerifiedConfirmationModal: React.FC<Props & DialogProps> = ({
  isOpen,
  onClose,
  userId,
  catalogId,
}) => {
  const dispatch = useDispatch();
  const { isFormLoading } = useSelector((state: any) => state.memberReducer);

  const handleCloseModal = () => {
    onClose && onClose();
  };

  const handleSubmit = (verifyKtp: boolean) => {
    dispatch(
      storeVerifyKTP(catalogId, userId, verifyKtp, handleCloseModal) as any
    );
  };

  return (
    <Dialog
      disableOverlayClick
      isOpen={isOpen}
      onClose={() => handleCloseModal()}
      overflowY={"auto"}
      maxWidth={"480px"}
      marginTop={260}
    >
      <DialogHeader>Konfirmasi Verifikasi KTP</DialogHeader>
      <DialogContent>
        <Text scale={400}>Apakah KTP yang ingin diverifikasi sudah benar?</Text>
      </DialogContent>
      <DialogFooter>
        <Stack
          display="flex"
          flexDirection="row"
          spacing="xs"
          flex={1}
          style={{ gap: 15, justifyContent: "center" }}
        >
          <Button
            variant="outline"
            onClickCapture={() => handleSubmit(false)}
            isLoading={isFormLoading}
            onClick={() => {}}
            icon={IconClose}
            iconPosition={"left"}
            width={200}
            height={45}
            style={{
              color: "white",
              backgroundColor: `${theme.colors.red05}`,
            }}
          >
            Tidak
          </Button>

          <Button
            variant="primary"
            onClickCapture={() => handleSubmit(true)}
            isLoading={isFormLoading}
            onClick={() => {}}
            icon={IconTickSingle}
            iconPosition={"left"}
            width={200}
            height={45}
            style={{
              color: "white",
              backgroundColor: `${theme.colors.green07}`,
            }}
          >
            Ya
          </Button>
        </Stack>
      </DialogFooter>
    </Dialog>
  );
};

export default KTPVerifiedConfirmationModal;
